<template>
  <page :loading="loading">
    <template #content>
      <SubTopBar/>
      <v-breadcrumbs
        :items="bcItems"
        divider=">"
        class="mt-1"
        large
        />
      <v-form ref="form" v-model="valid">
        <v-row>
          <v-col cols="12" class="mb-n5">
            <v-text-field
              v-model="sshKeyLabel"
              ref="keyLabel"
              outlined
              dense
              label="Label"
              :disabled="update"
              :rules="[global.rules.minLength]"
            />
          </v-col>
          <v-col cols="12" class="mb-n5">
            <v-textarea
              ref="keyValue"
              v-model="sshKeyValue"
              outlined
              dense
              label="SSH key"
              :rules="[global.rules.requiredField]"
            />
          </v-col>
          <v-col cols="12" class="mb-n5">
            <v-btn color="primary" :disabled="!valid" @click="addSshKeyOnClick" v-if="!editSshKey">Add key</v-btn>
            <v-btn color="primary" @click="editSshKeyOnClick" v-if="editSshKey">Update key</v-btn>
            <v-btn text @click="close">Cancel</v-btn>
          </v-col>
        </v-row>
      </v-form>
    </template>
  </page>
</template>

<script>
import SettingsStrings from "./SettingsStrings.js"
const Iam = require('iam')

export default {
  data() {
    return {
      keyLabel: "",
      keyValue: "",
      sshKeyLabel: "",
      sshKeyValue: "",
      alertDetail: "",
      valid: true,
      loading: true
    }
  },
  computed: {
    editSshKey: function () { return this.$route.params.publicKey },
    update: function () { return "undefined" !== typeof this.$route.params.publicKey },
    bcItems: function (){
      return [
        {},
        {
          text: "Settings",
          disabled: false,
          exact: true,
          to: {name: 'Settings'},
        },
        {
          text: "SSH keys ",
          disabled: false,
          exact: true,
          to: {name: "SshKeys"},
        },
        {
          text: `${this.$route.meta.bcText}`,
          disabled: false,
          exact: true,
          href: `${this.$route.path}`
        },
      ]}
  },
  created: function () {
    if (this.editSshKey) {
      this.$api.getPublicKey(this.editSshKey, this.username, this.callBack(
        (ctx) => {
          this.sshKeyLabel = ctx.label
          this.sshKeyValue = ctx.publickey
        }
      ))
    }
    
  },
  methods: {
    addSshKeyOnClick() {
      if (!this.$refs.form.validate()) return
      const key = new Iam.PublicKey()
      key.label = this.sshKeyLabel
      key.publicKey = this.sshKeyValue
      this.$api.addPublicKey(key, this.username, this.callBack(
        this.close,
        error => {
          if (error.status == 409) {
            this.alert(
              "error",
              SettingsStrings(this, "conflict_ssh"),
              undefined,
              undefined,
              () => {
                this.sshKeyLabel = ""
                this.$refs.keyLabel.focus()
              }
            )
          } else if (error.status == 400 || this.sshKeyLabel === "") {
            this.alert(
              "error",
              SettingsStrings(this, "invalid_ssh_key"),
              undefined,
              undefined,
              () => {
                this.sshKeyValue = ""
                this.$refs.keyValue.focus()
              }
            )
          } else {
            this.alert(
              "error",
              SettingsStrings(this, "server_error"),
              undefined,
              undefined,
              () => {
                this.sshKeyLabel = ""
                this.sshKeyValue = ""
                this.$refs.keyLabel.focus()
              }
            )
          }
        }
      ))
    },
    editSshKeyOnClick() {
      let body = new Iam.PublicKey()
      body.label = this.sshKeyLabel
      body.publickey = this.sshKeyValue 
      let username = this.username 
      this.$api.updatePublicKey(body,this.$route.params.publicKey , username, this.callBack(this.close))
    },
  },
  mounted() {
    this.loading = false
  }
}
</script>